var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaybe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2394 4.19308C9.2394 5.77104 7.96021 7.05022 6.38225 7.05022C4.8043 7.05022 3.52511 5.77104 3.52511 4.19308C3.52511 2.61512 4.8043 1.33594 6.38225 1.33594C7.96021 1.33594 9.2394 2.61512 9.2394 4.19308Z",
    fill: "#252919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0965 14.6693C12.0965 11.5134 9.53817 8.95498 6.38225 8.95498C3.22634 8.95498 0.667969 11.5134 0.667969 14.6693H12.0965Z",
    fill: "#252919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1442 6.09784C10.6182 6.09784 10.1918 6.52424 10.1918 7.05022C10.1918 7.57621 10.6182 8.0026 11.1442 8.0026H14.9537C15.4797 8.0026 15.9061 7.57621 15.9061 7.05022C15.9061 6.52424 15.4797 6.09784 14.9537 6.09784H11.1442Z",
    fill: "#252919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaybe);
export default __webpack_public_path__ + "static/media/maybe.4d60fbd3bc4f5648f3b2665f423a8ce8.svg";
export { ForwardRef as ReactComponent };